import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import './CandidateDashboard.css';
import DashboardLayout from './DashboardLayout';
import GlobalCandidateSettings from './GlobalCandidateSettings';
import { FaUserNinja } from 'react-icons/fa';

const ResumeAdd = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const userName = location.state?.userName;
  const userId = location.state?.userId;

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState(location.state?.fileType || 'file');
  const [link, setLink] = useState('');
  const [briefMessage, setBriefMessage] = useState('');
  const [message, setMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isSearchable, setIsSearchable] = useState(false);
  const [searchDescription, setSearchDescription] = useState('');

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMessage('File size must be less than 2MB. Try again');
      setFile(null);
      return;
    }

    setErrorMessage('');
    setFile(selectedFile);
  };

  const handleBriefMessageChange = (event) => {
    setBriefMessage(event.target.value);
  };

  const handleFileTypeChange = (event) => {
    setFileType(event.target.value);
    setErrorMessage('');
  };

  const handleLinkChange = (event) => {
    setLink(event.target.value);
  };

  const handleTextFileChange = (event) => {
    const uploadedFile = event.target.files[0];

    // Check if the file is a text file
    if (uploadedFile && uploadedFile.type === 'text/plain' && uploadedFile.size > 2 * 1024 * 1024) {
      const reader = new FileReader();

      reader.onload = function (e) {
        const fileContent = e.target.result;

        // Check the length of the file content
        if (fileContent.length > 300) {
          setErrorMessage('The brief resume content must be less than 300 characters.');
          setBriefMessage(fileContent); // Reset the brief message if the content is invalid
        } else {
          setErrorMessage(''); // Clear any previous error
          setBriefMessage(fileContent);
        }
      };

      reader.readAsText(uploadedFile);
    }
  };

  const isValidUrl = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === 'https:';
    } catch (_) {
      return false;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage('');

    if (fileType === 'link' && !isValidUrl(link)) {
      setErrorMessage('Please enter a valid link.');
      setLoading(false);
      return;
    }

    if (fileType === 'brief' && briefMessage.length > 300) {
      setErrorMessage('Brief Resume content cannot exceed 300 characters.');
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append('userId', userId);
    formData.append('fileType', fileType);
    formData.append('message', message);

    // New fields
    formData.append('isSearchable', isSearchable); // boolean
    formData.append('searchDescription', searchDescription); // textarea

    // Resume-specific fields
    if (fileType === 'file') {
      formData.append('file', file);
    } else if (fileType === 'link') {
      formData.append('link', link);
    } else if (fileType === 'brief') {
      formData.append('briefMessage', briefMessage);
    }

    try {
      // If it's a .txt file uploaded for brief, read it
      if (file && file.type === 'text/plain') {
        const reader = new FileReader();
        reader.onload = async function (event) {
          formData.set('briefMessage', event.target.result);
          await uploadResume(formData);
          setLoading(false);
          setShowModal(true);
          setSuccessMessage('Resume uploaded successfully!');
        };
        reader.readAsText(file);
      } else {
        await uploadResume(formData);
        setLoading(false);
        setShowModal(true);
        setSuccessMessage('Resume uploaded successfully!');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage('Something went wrong while uploading.');
      setLoading(false);
    }
  };


  const uploadResume = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_API_URL}/uploadResume`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error('Error uploading Resume:', error);
    throw error;
  }
};

  const handleBack = () => {
   // navigate('/candidate-dashboard/resume', { state: { userName, userId } });
   navigate(-1)
  };

  const handleOk = () => {
    setSuccessMessage('');
    setShowModal(false);
  };

  return (
    <DashboardLayout>
      <div className="main-content">
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2 className='text-start' style={{ paddingLeft: '12px', marginBottom: 0 }}>Add Resume</h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} />

          </Col>
        </Row>
        <Col xs={6} style={{ marginTop: '20px', marginLeft: '20px' }}>
          <Button onClick={handleBack} variant="secondary">
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
        </Col>

        <Col sm={9} className='resume-page' style={{ paddingLeft: '20px' }}>
          <Form onSubmit={handleSubmit} className='resume-Add'>
            <Form.Group as={Row} className='select-type'>
              <Form.Label column sm={3}>Select Type:</Form.Label>
              <Col sm={9}>
                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                  {['file', 'link', 'brief'].map((type) => (
                    <label
                      key={type}
                      className={`btn btn-outline-primary ${fileType === type ? 'active' : ''}`}
                    >
                      <input
                        type="radio"
                        value={type}
                        checked={fileType === type}
                        onChange={handleFileTypeChange}
                      /> {type === 'file' ? 'File' : type === 'link' ? 'Link' : 'Brief or Ninja apply'}
                    </label>
                  ))}
                </div>
              </Col>
            </Form.Group>

            {fileType === 'file' && (
              <Form.Group as={Row} className='select-file'>
                <Form.Label column sm={3}>Select File:</Form.Label>
                <Col sm={9}>
                  <Form.Control type='file' accept='.jpg, .jpeg, .png, .pdf, .doc, .docx' onChange={handleFileChange} required />
                </Col>
              </Form.Group>
            )}

            {fileType === 'link' && (
              <>
                <Form.Group as={Row} className='select-link'>
                  <Form.Label column sm={3}>Enter Link:</Form.Label>
                  <Col sm={9}>
                    <Form.Control type='text' value={link} onChange={handleLinkChange} required />
                    {/* {errorMessage && <div className="text-danger mt-1">{errorMessage}</div>} */}
                  </Col>
                </Form.Group>
                <div className="note-container">
                  <p className="note-text">You can apply using a resume or LinkedIn profile link.</p>
                </div>
              </>
            )}

            {fileType === 'brief' && (
              <>
                <Form.Group as={Row} className='message-type' style={{ alignItems: 'center' }}>
                  <Form.Label column sm={3}>Brief Resume: </Form.Label>
                  <Col sm={9} style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Control
                      as='textarea'
                      placeholder='Write or upload a .txt file'
                      value={briefMessage}
                      onChange={handleBriefMessageChange}
                      disabled={!!file}
                      required
                      style={{ flex: 1, marginRight: '10px', resize: 'vertical', minHeight: '50px' }}
                    />
                    <FaUserNinja
                      style={{ fontSize: '3rem', color: '#333', cursor: 'pointer' }}
                      title="search and apply jobs in stealth mode like a ninja"
                    />
                  </Col>
                </Form.Group>


                <Form.Group as={Row} className='select-file'>
                  <Form.Label column sm={3}>Upload Text File:</Form.Label>
                  <Col sm={9}>
                    <Form.Control type='file' accept='.txt' onChange={handleTextFileChange} />
                    {/* {errorMessage && <div className="text-danger mt-1">{errorMessage}</div>} */}
                  </Col>
                </Form.Group>
                <div className="note-container">
                  <p className="note-text">
                    You can use this to apply in stealth mode without sharing all details to HR.
                  </p>
                </div>
              </>
            )}

            <Form.Group as={Row} className='message-type' style={{ marginTop: '20px' }}>
              <Form.Label column sm={3}>Resume Title:</Form.Label>
              <Col sm={9}>
                <Form.Control type='text' value={message} onChange={(e) => setMessage(e.target.value)} required />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className='is-searchable'>
              <Form.Label column sm={3}>Searchable:</Form.Label>
              <Col sm={9} className="d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  checked={isSearchable}
                  onChange={(e) => setIsSearchable(e.target.checked)}
                  label="Allow recruiters to find this resume"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className='search-description'>
              <Form.Label column sm={3}>Search Description:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as='textarea'
                  rows={3}
                  value={searchDescription}
                  onChange={(e) => setSearchDescription(e.target.value)}
                  placeholder="Describe your skills or highlight keywords for searchability"
                  disabled={!isSearchable}
                  required={isSearchable}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={{ span: 9, offset: 3 }}>
                <Button type="submit" className='uploadResume' disabled={loading}>
                  {loading ? 'Uploading...' : 'Upload Resume'}
                </Button>
              </Col>
              {errorMessage && <div className="text-danger mt-1"> Uploading failed -- {errorMessage}</div>}
            </Form.Group>
          </Form>

          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Success!</Modal.Title>
            </Modal.Header>
            <Modal.Body>{successMessage}</Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleOk}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </div>
    </DashboardLayout>
  );
};

export default ResumeAdd;
